import DomComponent from '../../lib/domComponent';
import body from '../../services/body';
import { each, mq } from '../../lib/util';
import { duration } from '../../lib/const';

export default class ModalComponent extends DomComponent {
    static selector = '[data-js-modal]';
    static defaultOpts = {
        cache: true
    }

    constructor(el) {
        super(el, ModalComponent.defaultOpts);

        if(!this.el) {
            return;
        }

        this.closeButton = this.el.querySelector('[data-close]');
        this.background = this.el.querySelector('[data-bg]');
        this.modalTriggers = document.querySelectorAll('[data-modal-target]');
        this.modalContents = this.el.querySelectorAll('[data-modal-content]');
        this.videoModalContent = this.el.querySelector('[data-modal-content="video-modal"]');
        this.modalBox = this.el.querySelector('[data-modal-box]');
        this.youtubeVideoModalTriggers = document.querySelectorAll('[data-video-id]');
        this.iframeModalTriggers = document.querySelectorAll('[data-iframe-src]');
        this.video = document.querySelector('[data-modal-video]');
        this.formWidgetSelector = '.form-widget';

        this.closeButton.addEventListener('click', this.closeModalHandler.bind(this));

        if(this.background) {
            this.background.addEventListener('click', this.closeModalHandler.bind(this));

        }

        each(this.youtubeVideoModalTriggers, (trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.prepareYoutubeVideo(trigger.dataset.videoId);
                this.openModal(this.videoModalContent);
            })
        });

        each(this.iframeModalTriggers, (trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.prepareIframe(trigger.dataset.iframeSrc);
                this.openModal(this.videoModalContent);
            })
        });

        // triggers that open modal
        each(this.modalTriggers, (trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                const target = trigger.dataset.modalTarget;
                each(this.modalContents, (content) => {
                    if(target === content.dataset.modalContent) {
                        this.openModal(content);
                    }
                });
            })
        });

        each(this.modalContents, (content) => {
            const formWidget = content.querySelector(this.formWidgetSelector);

            // formulate modal logic
            if ( formWidget ) {
                formWidget.addEventListener('formulate form: submit: success', (e) => {
                    this.successHandler(e, content);
                })
            }
        });


        setTimeout(() => {
            this.loaded();
        });
    }

    updateHeader(node, text) {
        node.querySelector('h2').innerText = text;
    }

    successHandler(e, content) {
        this.updateHeader(content, 'THANK YOU.');
    }

    addIframeTriggers(nodeList) {
        each(nodeList, (node) => {
            node.addEventListener('click', (e) => {
                e.preventDefault();
                this.prepareIframe(node.dataset.iframeSrc);
                this.openModal(this.videoModalContent);
            })
        })
    }

    addIframeVimeoTriggers(nodeList) {
        each(nodeList, (node) => {
            node.addEventListener('click', (e) => {
                e.preventDefault();
                let vimeoId;
                if (mq('sm')) {
                    vimeoId = node.dataset.desktopVideoId;
                } else {
                    vimeoId = node.dataset.mobileVideoId;
                }
                this.prepareVimeoVideo(vimeoId);
                this.openModal(this.videoModalContent);
            })
        })
    }

    addYouTubeTriggers(nodeList) {
        each(nodeList, (node) => {
            node.addEventListener('click', (e) => {
                e.preventDefault();
                this.prepareYoutubeVideo(node.dataset.videoId);
                this.openModal(this.videoModalContent);
            })
        })
    }

    closeModalHandler() {
        this.el.classList.remove('open');
        body.unlock();

        setTimeout(() => {
            each(this.modalContents, (content) => {content.style.display = 'none'});
            this.video.removeAttribute('src');
            this.el.classList.remove('modal--video');
        }, duration)
    }

    prepareVimeoVideo(videoId) {
        this.prepareIframe(`https://player.vimeo.com/video/${videoId}?amp;color=ffffff&title=0&byline=0&portrait=0&autoplay=1&transparent=0`);
    }

    prepareYoutubeVideo(videoId) {
        this.prepareIframe(`https://www.youtube.com/embed/${videoId}`)
    }

    prepareIframe(src) {
        this.video.setAttribute('src', src);
        this.el.classList.add('modal--video');
    }

    openModal(node) {
        node.style.display = '';
        this.el.classList.add('open');
        body.lock();
    }
}